import { Flex } from '@banhala/ui-kit';
import type { HeadlineLargeTwoLineProps } from './types';
import { isNil, isNotNil } from '../../../../utils';
import { HTMLText } from '../../../HTMLText';

export const HeadlineLargeTwoLine = ({
  header,
}: HeadlineLargeTwoLineProps) => {
  if (isNil(header)) return null;

  return (
    <Flex.Column
      gap={8}
      alignItems="center"
      padding={{ top: 24, horizontal: 16, bottom: 16 }}
    >
      <HTMLText
        type="h3"
        color="content_primary"
        numberOfLines={1}
        textAlign="center"
      >
        {header.item.title}
      </HTMLText>
      {isNotNil(header.item.sub_title) && (
        <HTMLText type="body1" color="content_secondary" textAlign="center">
          {header.item.sub_title}
        </HTMLText>
      )}
    </Flex.Column>
  );
};
